export default __webpack_public_path__ + "static/media/wave.f7a5e75c.svg";